import { DEFAULT_COLORS, SURFACE_COLORS, TEXT_COLORS } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import { Pagination as AntdPagination } from 'antd';
import styled from 'styled-components';

export const Pagination = styled(AntdPagination)<{ contentText: string }>`
    & {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        margin: 24px 0;
        padding: 8px 0;
    }

    li {
        margin: 0 4px;
        border-radius: 4px;
    }

    .ant-pagination {
        display: flex;
        align-items: center;
        flex: 1;
    }

    .ant-pagination-prev,
    .ant-pagination-next,
    .ant-pagination-item > a {
        margin: 0 4px;
        color: ${TEXT_COLORS.action};
        ${FONT_FAMILY.poppins};
        ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontSize};
        ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontWeight};
    }

    .ant-pagination-prev,
    .ant-pagination-next,
    .ant-pagination-item-link {
        margin: 0 4px;
        color: ${TEXT_COLORS.action} !important;
        ${FONT_FAMILY.poppins};
        ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontSize};
        ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontWeight};
    }

    .ant-pagination-item-active {
        border-radius: 8px;
        border: 1px solid ${TEXT_COLORS.action};
        background: ${SURFACE_COLORS.page};
    }

    .ant-pagination-item-active > a {
        color: ${TEXT_COLORS.action};
        ${FONT_FAMILY.poppins};
        ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontSize};
        ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontWeight};
    }

    li.ant-pagination-options {
        margin-left: auto;
        display: flex;
        align-items: center;

        &::before {
            content: '${(props) => props.contentText}';
            margin-right: 8px;
            white-space: nowrap;
            color: ${TEXT_COLORS.body};
            ${FONT_FAMILY.poppins};
            ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize};
            ${DESKTOP_SIZES[SIZES.BODY_SM].fontWeight};
            ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight};
        }

        .ant-select-selector {
            border-radius: 8px;
            border: 1px solid ${TEXT_COLORS.disabled};
            background: ${DEFAULT_COLORS.white};
        }
    }
`;
